import axios from "@axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    loadingRoles: false,
    userView: {
      roles: [],
      governorate: {},
      ministry: {},
    },
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    loadingRoles(state) {
      return state.loadingRoles;
    },
    userView(state) {
      return state.userView;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setLoadingRoles(state, val) {
      state.loadingRoles = val;
    },
    setUserView(state, val) {
      state.userView = val;
    },
  },
  actions: {
    fetchUser({ commit }, { id, isMinistry }) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        const endpoint = isMinistry
          ? `v2/ministry/ministry-users/${id}`
          : `v2/ministry/ngo-users/${id}`;
        axios
          .get(endpoint)
          .then((response) => {
            if (response.data.data) {
              resolve(response);
              commit("setUserView", response.data.data);
            } else reject();
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
    fetchUserLog({ commit }, { id, isMinistry = false }) {
      commit("setLoading", true);
      const endpoint = isMinistry
        ? `v2/ministry/ministry-users-log/${id}`
        : `v2/ministry/ngo-users-log/${id}`;
      return new Promise((resolve, reject) => {
        axios
          .get(endpoint)
          .then((response) => {
            if (response.data.data) resolve(response);
            else reject();
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
    fetchUserRoles({ commit }, { id, isMinistry }) {
      commit("setLoadingRoles", true);
      return new Promise((resolve, reject) => {
        axios
          .get(`v2/ministry/users-roles/${id}`, { params: { isMinistry } })
          .then((response) => {
            if (response.data.data) resolve(response);
            else reject();
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoadingRoles", false);
          });
      });
    },
    changeRole({ commit }, { id, roleId, isMinistry }) {
      commit("setLoadingRoles", true);
      return new Promise((resolve, reject) => {
        axios
          .post(
            `v2/ministry/users-roles/${id}`,
            { roleId },
            { params: { isMinistry } }
          )
          .then((response) => {
            if (response.status >= 400 && response.status <= 500)
              reject(response.status);
            else resolve(response);
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoadingRoles", false);
          });
      });
    },
    addUser({ commit }, { userData, isMinistry }) {
      commit("setLoading", true);
      delete userData.governorate;
      delete userData.ngoRoles;
      if (userData.phone && userData.phone.length === 0) delete userData.phone;

      const endpoint = isMinistry
        ? "v2/ministry/ministry-users"
        : "v2/ministry/ngo-users";
      return new Promise((resolve, reject) => {
        axios
          .post(endpoint, userData)
          .then((response) => {
            if (response.status >= 400 && response.status <= 500)
              reject(response.status);
            else resolve(response);
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
    restoreUser({ commit }, { id, isMinistry }) {
      commit("setLoading", true);
      const endpoint = isMinistry
        ? `v2/ministry/ministry-users/restore/${id}`
        : `v2/ministry/ngo-users/restore/${id}`;
      return new Promise((resolve, reject) => {
        axios
          .post(endpoint)
          .then((response) => {
            if (response.status >= 400 && response.status <= 500)
              reject(response.status);
            else resolve(response);
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
    updateUser({ commit }, { userData, isMinistry }) {
      commit("setLoading", true);
      delete userData.governorate;
      delete userData.ngoRoles;
      delete userData.ngo;
      if (userData.phone && userData.phone.length === 0) delete userData.phone;

      const endpoint = isMinistry
        ? "v2/ministry/ministry-users"
        : "v2/ministry/ngo-users";
      return new Promise((resolve, reject) => {
        axios
          .put(`${endpoint}/${userData.id}`, userData)
          .then((response) => {
            if (response.status >= 400 && response.status <= 500)
              reject(response.status);
            else resolve(response);
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
    deleteUser({ commit }, { id, isMinistry }) {
      commit("setLoading", true);
      const endpoint = isMinistry
        ? "v2/ministry/ministry-users"
        : "v2/ministry/ngo-users";
      return new Promise((resolve, reject) => {
        axios
          .delete(`${endpoint}/${id}`)
          .then((response) => {
            if (response.status >= 400 && response.status <= 500)
              reject(response.status);
            else resolve(response);
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
    changeUserPassword({ commit }, { passwordData, isMinistry }) {
      commit("setLoading", true);
      const userId = passwordData.id;
      delete passwordData.id;
      const endpoint = isMinistry
        ? "v2/ministry/ministry-users/change-password"
        : "v2/ministry/users/change-password-user";
      return new Promise((resolve, reject) => {
        axios
          .post(`${endpoint}/${userId}`, passwordData)
          .then((response) => resolve(response))
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
  },
};
